import { NullableString } from '../../util/types';

export type BaseCacheableType = {
    cacheKey: string,
    cacheTTL: number,
}

export type CacheableData = {
    data: any;
    cacheTime: number,
    cacheTTL: number,
}

export type CacheableDataType = {
    url: string,
    cacheName: CacheName,
    cacheKeys?: string[]
    cacheConditions?: Record<string, NullableString[]>
    cacheTTL: number,
    method: HttpMethods,
}

export enum HttpMethods {
    GET = 'GET',
    POST = 'POST',
    PUT = 'PUT',
    PATCH = 'PATCH',
    HEAD = 'HEAD',
    DELETE = 'DELETE',
    OPTIONS = 'OPTIONS',
    TRACE = 'TRACE'
}

export enum CacheName{
    EpicMovers = 'cache:epic-movers',
    marketCaps = 'cache:market-caps',
    searchCompanies = 'cache:search-companies',
    keyStatsBySymbols = 'cache:key-stats-by-symbols',
    companyBySymbols = 'cache:company-by-symbols',
    companyLogoAndNameBySymbols = 'cache:company-logo-and-name-by-symbols',
    companyLogoMD5BySymbols = 'cache:company-logo-md-by-symbols',
    popularStocks = 'cache:popular-stocks',
    sectors = 'cache:sectors',
    etfs = 'cache:etfs',
    statements = 'cache:statements',
    statementsCashFlow = 'cache:statements-cash-flow',
    statementsBalanceSheet = 'cache:statements-balance-sheet',
    statementsIncome = 'cache:statements-income',
    availableIndexes = 'cache:available-indexes',
    gappers = 'cache:gappers',
    week52HighLow = 'cache:week52-high-lows',
    week52HighLowTopList = 'cache:week52-high-low-top-list',
    ratiosByType = 'cache:ratios-by-type',
    ratiosValuation = 'cache:ratios-valuation',
    ratiosProfitability = 'cache:ratios-profitability',
    ratiosLiquidityAndSolvency = 'cache:ratios-liquidity-and-solvency',
    symbolsBySector = 'cache:symbols-by-sectors',
    countries = 'cache:countries',
    orderDetailData = 'cache:order-detail',
    peopleAlsoTrade = 'cache:people-also-trade',
    clientPlatforms = 'cache:client-platforms',
    userPreferences = 'cache:user-preferences',
    nonWorkingDaysAndWorkingTime ='cache:get-nonworking-days-and-working-time',
}
